import { useCallback, useEffect, useState } from 'react'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { PlusIcon as CreateIcon, PenIcon as EditIcon } from 'lucide-react'

import Modal from 'components/Modal'
import { CreateFile } from './files-form-list/download-file'

const MODAL_OPTIONS = [
  {
    name: 'Download File',
    link: '?modal=download-files',
    type: 'download-files',
  },
] as const

const getModalOptions = () => {
return MODAL_OPTIONS
  }


type ModalOptionsType =
  | (typeof MODAL_OPTIONS)[number]['type']
  | undefined

type OptionType = (typeof MODAL_OPTIONS)[number] | null

const useFilesListActionsModal = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams() ?? undefined
  const queryModal =
    (searchParams.get('modal') as ModalOptionsType) ?? undefined
  const [isShowCreateModal, isShowCreateModalSet] = useState(false)
  const [isShowEditModal, isShowEditModalSet] = useState(false)
  const [optionType, optionTypeSet] = useState<OptionType>(null)

  const resetModal = useCallback(() => {
    isShowCreateModalSet(false)
    isShowEditModalSet(false)
    navigate('?modal=null')
  }, [isShowCreateModalSet, isShowEditModalSet, navigate])

  const handleModal = useCallback(
    (queryModal: ModalOptionsType) => {
      const modalOptions = getModalOptions()
      const filtered = modalOptions.filter(
        (item) => item.type === queryModal
      )[0]
      optionTypeSet(filtered)
    },
    [optionTypeSet]
  )

  useEffect(() => {
    if (queryModal === 'download-files') {
      isShowCreateModalSet(true)
      handleModal(queryModal)
    } else {
      resetModal()
    }
  }, [
    queryModal,
    isShowCreateModalSet,
    isShowEditModalSet,
    resetModal,
    handleModal,
  ])

  return {
    isShowCreateModal,
    isShowEditModal,
    resetModal,
    optionType,
  }
}

export const CreateFilesModal = () => {
  const { optionType, isShowCreateModal, resetModal } =
    useFilesListActionsModal()

  const modalOptions = getModalOptions()

  return (
    <>
      <div className="flex flex-col gap-4 w-max">
        {modalOptions.map((item) => (
          <button
            key={item.name}
            className="px-3 py-1 border rounded-md border-primary text-primary"
            type="button"
          >
            <Link to={item.link} className="flex items-center gap-2">
              <CreateIcon size={16} />
              <span className="tracking-wider font-light">{item.name}</span>
            </Link>
          </button>
        ))}
      </div>

      {optionType && (
        <Modal
          title={optionType.name}
          open={isShowCreateModal}
          onClose={resetModal}
          noFooter
        >
          {optionType.type === 'download-files' && (
            <CreateFile onCloseModal={resetModal} />
          )}
        </Modal>
      )}
    </>
  )
}
